import type { FC, ReactNode } from 'react'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

import { useAuth } from '../../store/useAuth'

interface GuestGuardProps {
  children: ReactNode
}

export const GuestGuard: FC<GuestGuardProps> = props => {
  const { children } = props
  const auth = useAuth(state => state.isAuthenticated)

  const router = useRouter()
  const [checked, setChecked] = useState(false)
  //   const disableGuard = router.query.disableGuard as string;

  useEffect(
    () => {
      if (!router.isReady) {
        return
      }

      if (auth) {
        router.push('/')
      } else {
        setChecked(true)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [router.isReady],
  )

  if (!checked) {
    return null
  }

  // If got here, it means that the redirect did not occur, and that tells us that the user is
  // not authenticated / authorized.

  return <>{children}</>
}

GuestGuard.propTypes = {
  children: PropTypes.node,
}
